// extracted by mini-css-extract-plugin
export default {"appliedTags":"index_appliedTags__8v5hA"};